import React from 'react'
import { experienceData } from './projectData';
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import BallSaperator from './BallSaperator';

export default function Experience() {
    return (

        <Container className="exp_wrap my-5 py-5">
            <h2 className="exp_heading">My Professional Experience</h2>

            <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={16}
                navigation
                pagination={{ clickable: true }}
                breakpoints={{
                    320: { slidesPerView: 1, spaceBetween: 12 },
                    480: { slidesPerView: 1.1 }, // slight peek effect
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                }}
            >
            {experienceData.map((item, index) => (
                <SwiperSlide key={index}>
                    <div
                        className={`exp_card ${item.duration.includes("Present") ? "active" : ""
                            }`}
                    >
                        <div className="exp_top">
                            <h5>{item.title}</h5>
                            <span>{item.duration}</span>
                        </div>

                        <p className="role">{item.role}</p>
                        <hr />

                        <p className="desc">{item.desc}</p>

                        <p className="subDesc">{item.subDesc}</p>

                        <div className="exp_bottom">
                            <span>{item.location}</span>
                            <a href={item.link} target="_blank" rel="noreferrer">
                                Visit →
                            </a>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
        </Container >

    )
}
